import { api } from './api';

const manualUpdateAPI = {
  createManualUpdate: (update) => api.post('/manual-updates', update),
  getManualUpdates: (containerNumber) => api.get(`/manual-updates/${containerNumber}`),
  getAgentHistory: () => api.get('/manual-updates/agent/history'), 
  bulkUpdateStatus: (updates) => api.post('/manual-updates/bulk', updates),

};

export default manualUpdateAPI;